import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '../catalyst-ui-kit/button';

type PnlCardErrorModalProps = {
  onClose: () => void;
};

export function PnlCardModalErrorContent({ onClose }: PnlCardErrorModalProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 p-6 text-center">
      <div className="flex size-16 items-center justify-center rounded-full bg-red-500/10">
        <ExclamationCircleIcon className="size-10 text-red-500" aria-hidden="true" />
      </div>
      <div className="flex flex-col space-y-3">
        <h1 className="text-2xl font-bold text-contentPrimary">An Unexpected Error Occurred</h1>
        <p className="text-contentSecondary">
          We apologize for the inconvenience. Our team has been notified and is working to resolve
          the issue.
        </p>
      </div>
      <div className="flex gap-4">
        <Button onClick={onClose} color="blue">
          Close
        </Button>
        <Button outline onClick={() => window.location.reload()}>
          Reload Page
        </Button>
      </div>
    </div>
  );
}
